var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgTt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7303_38640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.49763 1.33246C5.42335 1.88694 4.41493 2.61374 3.51436 3.5143C2.61375 4.41491 1.88696 5.42333 1.33252 6.49761L9.04847 14.9515L17.5023 22.6674C18.5767 22.1129 19.5851 21.3861 20.4856 20.4856C21.3863 19.585 22.113 18.5766 22.6675 17.5023L14.9515 9.04841L6.49763 1.33246Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4856 20.4856C20.989 19.9822 21.438 19.4451 21.8332 18.8817L5.11828 2.16675C4.55489 2.56195 4.01775 3.01092 3.51436 3.51431C3.01097 4.0177 2.562 4.55484 2.16675 5.11828L18.8817 21.8332C19.445 21.4379 19.9822 20.989 20.4856 20.4856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51431 20.4856C7.30026 24.2716 12.9861 24.9983 17.5023 22.6674L1.33251 6.49762C-0.998347 11.0138 -0.271457 16.6997 3.51431 20.4856V20.4856Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4855 3.51434C16.6996 -0.271568 11.0138 -0.998318 6.49756 1.33245L22.6673 17.5024C24.9982 12.9861 24.2715 7.30024 20.4855 3.51434V3.51434Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7303_38640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTt);
export default __webpack_public_path__ + "static/media/tt.08630bc39640baaa6b143c255384c346.svg";
export { ForwardRef as ReactComponent };